export default function CollapseTwo() {
    return (
        <div className="flex flex-col my-2 gap-4">
            <p>LANGINYL OD® (Bromhidrato de Galantamina) está indicada en el tratamiento de la demencia tipo Alzheimer
                de leve a moderadamente severa.</p>
            <img src={"./imgs/Langinyl-box.png"} alt="oxetol-box.png" className="col-span-6"/>

        </div>
    );
}